<template>
  <div class="container my-5">
    <!-- <div class="text-center title-pp font-weight-bold py-5">GOGOCinema Help Page</div> -->

    <p class="">For any queries related please write to <br><a href="">support@gogocinema.com</a><br> We will get back to you as soon as possible.</p><br>
    <p class="font-weight-bold mb-0">For any feedback</p>
    <p class="">Please write in feedback section of your profile: We appreciate your feedback and suggestions.It will help us improve our services to our users.</p>
  </div>
</template>

<script>
export default {
  name: "Help-page",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {},

  data() {
    return {};
  }
};
</script>

<style scoped>
.text-pp {
  font-size: 14px;
}

.title-pp {
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/help-page.vue